<template>
  <div id="report_content">
    <div class="spinner_container" v-if="loading">
      <b-spinner />
    </div>

    <div v-if="section == 'ledgers'">
      <MetricsLedgersClosed :subreport="have_period" />
      <MetricsLedgersClosedCard v-if="have_period"/>
    </div>

    <div v-if="section == 'fees'">
      <MetricsFeesBurnt :subreport="have_period" />
    </div>

    <div v-if="section == 'txs'">
      <MetricsTransactionRate :subreport="have_period"/>

      <div v-if="have_period">
        <b-container class="p-0">
          <b-row no-gutters>
            <b-col class="pr-2">
              <MetricsTransactionRateCard />
            </b-col>

            <b-col class="pl-2">
              <MetricsTransactionFeesCard />
            </b-col>
          </b-row>

          <b-row no-gutters style="margin-top: 10px">
            <b-col class="pr-2">
              <MetricsPaymentsCard />
            </b-col>

            <b-col class="pl-2">
              <MetricsOffersCard />
            </b-col>
          </b-row>

          <b-row no-gutters style="margin-top: 10px;">
            <b-col  v-bind:cols="$mq == 'sm' ? 12 : 6"
                   v-bind:class="$mq == 'sm' ? '' : 'pr-2'">
              <MetricsPaymentsByCurrency />
            </b-col>

            <b-col  v-bind:cols="$mq == 'sm' ? 12 : 6"
                   v-bind:class="$mq == 'sm' ? 'mt-3' : 'pl-2'">
              <MetricsOffersByCurrencyPair />
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>

    <div v-if="section == 'tx_types'">
      <MetricsTxTypes :subreport="have_period" />
    </div>

    <div v-if="section == 'accounts'">
      <MetricsAccountRate :subreport="have_period"/>

      <div v-if="have_period">
        <b-container class="p-0">
          <b-row no-gutters>
            <b-col cols=6 class="pr-2">
              <MetricsTotalAccountsCard />
            </b-col>

            <b-col cols=6 class="pl-2">
              <MetricsAccountRateCard />
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <MetricsActiveAccounts />
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import MetricsLedgersClosed        from './metrics/LedgersClosed.vue'
import MetricsTransactionRate      from './metrics/TransactionRate.vue'
import MetricsAccountRate          from './metrics/AccountRate.vue'
import MetricsFeesBurnt            from './metrics/FeesBurnt.vue'
import MetricsTxTypes              from './metrics/TxTypes.vue'

import MetricsLedgersClosedCard    from './metrics/cards/LedgersClosed.vue'
import MetricsTransactionRateCard  from './metrics/cards/TransactionRate.vue'
import MetricsTransactionFeesCard  from './metrics/cards/TransactionFees.vue'
import MetricsPaymentsCard         from './metrics/cards/Payments.vue'
import MetricsOffersCard           from './metrics/cards/Offers.vue'
import MetricsTotalAccountsCard    from './metrics/cards/TotalAccounts.vue'
import MetricsAccountRateCard      from './metrics/cards/AccountRate.vue'

import MetricsActiveAccounts       from './metrics/ActiveAccounts.vue'
import MetricsPaymentsByCurrency   from './metrics/PaymentsByCurrency.vue'
import MetricsOffersByCurrencyPair from './metrics/OffersByCurrencyPair.vue'

import config from '../../config'

function cancel_timeout(vue){
  if(!vue.report_timeout) return;

  clearTimeout(vue.report_timeout);
  vue.report_timeout = null;
}

function get_default_report(vue){
  cancel_timeout(vue);
  vue.loading = true

  var uri = config.DATA_URI + "/report/" + vue.period +
                              "?metrics=" + config.DEFAULT_REPORT_METRICS.join(",");
  vue.$http.get(uri)
     .then(function(response){
       // XXX: handle case where get request is invoked
       //      before we switch to a specific report,
       //      and the callback doesn't return until after
       //      resulting in inconsistent data.
       if(vue.have_period) return;

       vue.loading = false;

       vue.$store.commit('clear_report_data');
       vue.$store.commit('set_report_data', response["body"]);
       vue.$store.commit('set_report_retrieved', new Date().toISOString());

       // schedule periodic resync
       vue.report_timeout =
         setTimeout(function(){
           get_default_report(vue);

         // two minute buffer to allow report to be generated
         }, config.REPORT_INTERVAL_MINUTES * 60 * 1000 + 120000);

     // on fail try again
     }, function(){
       vue.loading = false;
       vue.report_timeout =
         setTimeout(function(){ get_default_report(vue); },
                    config.RETRY_SECONDS * 1000);
     });
}

function get_selected_report(vue){
  cancel_timeout(vue);

  var period = vue.selected_report.period 
  var timestamp = vue.selected_report.timestamp;
  if(period == 'month')
    timestamp = timestamp.replace("/", "-01-");

  ///

  vue.loading = true;
  var loaded_report = false;
  var loaded_subreport = false;

  ///

  var report_uri = config.DATA_URI + "/report/" + period + "/" + timestamp +
                    "?metrics=" + config.TIMESTAMP_REPORT_METRICS.join(",");
  vue.$http.get(report_uri)
     .then(function(response){
       loaded_report = true;
       vue.loading = !(loaded_report && loaded_subreport);

       vue.$store.commit('clear_report_data');
       vue.$store.commit('set_report_data', response["body"]);

     // on fail try again
     }, function(){
       loaded_report = true;
       vue.loading = loaded_report && loaded_subreport;

       vue.report_timeout =
         setTimeout(function(){ get_selected_report(vue); },
                    config.RETRY_SECONDS * 1000);
     });

  ///

  var subperiod = vue.selected_report.subperiod;
  var subreport_uri = config.DATA_URI + "/report/" + period + "/" + timestamp +
                                                    "?subperiod=" + subperiod +
                         "&metrics=" + config.DEFAULT_REPORT_METRICS.join(",");
  vue.$http.get(subreport_uri)
     .then(function(response){
       loaded_subreport = true;
       vue.loading = !(loaded_report && loaded_subreport);

       vue.$store.commit('clear_subreport_data');
       vue.$store.commit('set_subreport_data', response["body"]);

     // on fail try again
     }, function(){
       loaded_subreport = true;
       vue.loading = loaded_report && loaded_subreport;

       vue.report_timeout =
         setTimeout(function(){ get_selected_report(vue); },
                    config.RETRY_SECONDS * 1000);
     });
}

export default {
  name: 'ReportContent',

  components : {
    MetricsLedgersClosed,
    MetricsTransactionRate,
    MetricsAccountRate,
    MetricsFeesBurnt,
    MetricsTxTypes,

    MetricsLedgersClosedCard,
    MetricsTransactionRateCard,
    MetricsTransactionFeesCard,
    MetricsPaymentsCard,
    MetricsOffersCard,
    MetricsTotalAccountsCard,
    MetricsAccountRateCard,

    MetricsActiveAccounts,
    MetricsPaymentsByCurrency,
    MetricsOffersByCurrencyPair
  },

  data : function(){
    return {loading : false};
  },

  computed : {
    section : function() {
      return this.$store.state.report.section;
    },

    period : function(){ 
      return this.$store.state.report.period;
    },

    selected_report : function(){
      return this.$store.state.report.selected;
    },

    have_period : function(){
      return !!this.selected_report.period;
    },
  },

  created : function(){
    if(this.have_period)
      get_selected_report(this);
    else
      get_default_report(this);
  },

  watch : {
    period : function(){
      if(!this.have_period)
        get_default_report(this);
    },

    selected_report : function(){
      if(this.have_period)
        get_selected_report(this);
      else
        get_default_report(this);
    },
  }
}
</script>

<style scoped>
#report_content{
  padding-top: 25px;
}

.spinner_container{
  margin-top: 10px;
  min-height: unset;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
